import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { NGXLogger, NgxLoggerLevel } from "ngx-logger";

@Injectable()
export class LogRequestsInterceptor implements HttpInterceptor {

  // Redni broj umesto Math.random() — kraće linije i vidljiv redosled zahteva u logu.
  private static nextRequestID = 1;

  constructor(private logger: NGXLogger) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const id = LogRequestsInterceptor.nextRequestID++;
    const startedAt = Date.now();

    // Puni URL sa query parametrima samo na TRACE (dev / terenska dijagnostika).
    this.logger.trace(`[${id}] ${req.method} ${req.urlWithParams} started`);

    return next.handle(req)
      .pipe(
        tap({
          next: evt => {
            if (evt instanceof HttpResponse) {
              const b = evt.body ?? {};
              // Metod + putanja + trajanje idu u SVAKU debug liniju — ranije je URL stajao
              // samo u TRACE "started" liniji, pa su produkcijski logovi (DEBUG nivo)
              // imali statuse zahteva bez ikakve veze sa endpointom.
              const elapsed = Date.now() - startedAt;

              // JSON.stringify CELOG body-ja (meni/session su više MB) se ranije računao
              // bez obzira na nivo logovanja i primetno koštao pri hladnom startu na
              // sporim uređajima — sada samo kad se TRACE stvarno loguje.
              const traceOn = this.logger.getConfigSnapshot().level <= NgxLoggerLevel.TRACE;
              const lengthPart = traceOn ? `, length: ${JSON.stringify(evt.body).length}` : '';

              // success samo kad body zaista ima boolean success (Blob/tuđi API nemaju).
              const successPart = typeof b.success === 'boolean' ? `, success: ${b.success}` : '';

              this.logger.debug(`[${id}] ${req.method} ${req.url} ${evt.status} in ${elapsed}ms${successPart}${lengthPart}${b?.errorDescription ? `, errorCode: ${b.errorCode}, error: ${b.errorDescription}` : ''}`);
            }
          },
          error: err => {
            const status = err?.status ?? '(no status)';
            this.logger.debug(`[${id}] ${req.method} ${req.url} ERROR after ${Date.now() - startedAt}ms: status=${status}; message=${err?.message}; name=${err?.name}`, err);
          }
        })
      );
  }

}
